import apiClient from '@/api/apiClient';

export default {
  login(role, visitorToken) {
    return apiClient.post("/api/customer/user/login", {
      role: role || null,
      visitorToken: visitorToken || null
    });
  },
};
